module.exports = __webpack_public_path__ + "static/media/newsEvent3.0083fc6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/images/newsEvent3.jpg
// module id = 107
// module chunks = 0